import { render, staticRenderFns } from "./DecosTab.vue?vue&type=template&id=105e89ca&"
import script from "./DecosTab.vue?vue&type=script&lang=ts&"
export * from "./DecosTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports